module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_7005.ab8f85d0.png";